"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeNoComparisonSpec = void 0;
/**
 * @param message The message to display when presented as an option in the
 * adjust and compare screen. Defaults to the empty string.
 */
var makeNoComparisonSpec = function (message) {
    if (message === void 0) { message = ''; }
    return {
        type: 'NO_COMPARISON',
        message: message,
    };
};
exports.makeNoComparisonSpec = makeNoComparisonSpec;
//# sourceMappingURL=NoComparisonSpec.js.map